import * as React from 'react';
import TransferList from '../../../../common/transfer-list';
import Client from '../../../../../models/client';
import _ from 'lodash';
import { CircularProgress } from '@material-ui/core';
import SupportAllowedType from '../../../../../models/supportAllowedType';
import { useSupportTypes } from '../../../../../hooks/useSupportTypes';
import * as styles from '../client-admin.module.scss';

interface Props {
  client: Client;
  // FormikHelper.setFieldValue
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  supportType: 'organizations' | 'request-types';
}

const SupportTypeTransfer = ({ client, setFieldValue, supportType }: Props) => {
  const supportTypeQuery = useSupportTypes(supportType);
  const [unassigned, setUnassigned] = React.useState<SupportAllowedType[]>([]);
  const [assigned, setAssigned] = React.useState<SupportAllowedType[]>(
    supportType == 'organizations' ? client.assignedOrganizations : client.assignedRequestTypes
  );

  React.useEffect(() => {
    if (supportTypeQuery.data && assigned.length == 0) {
      setUnassigned(supportTypeQuery.data);
    } else if (supportTypeQuery.data && assigned.length > 0) {
      setUnassigned(_.differenceBy(supportTypeQuery.data, assigned, 'key'));
    }
  }, [supportTypeQuery.data, client]);

  return (
    <React.Fragment>
      <h2 className={styles.formSectionHeading}>
        {supportType == 'organizations' ? 'Service Desk Organizations' : 'Service Desk Request Types'}{' '}
        {(supportTypeQuery.isLoading || supportTypeQuery.isFetching) && <CircularProgress size="1em" />}
      </h2>
      <TransferList
        idField="key"
        labelField="value"
        left={unassigned}
        right={assigned}
        setLeft={setUnassigned}
        setRight={setAssigned}
        setFieldValue={setFieldValue}
        setField={supportType == 'organizations' ? 'assignedOrganizations' : 'assignedRequestTypes'}
      />
    </React.Fragment>
  );
};

export default SupportTypeTransfer;
